// @flow

export const USERDATA_INITIAL: string = 'USERDATA_INITIAL';
export const USERDATA_FORM_SUBMIT: string = 'USERDATA_FORM_SUBMIT';
export const USERDATA_UPDATE_LOADER: string = 'USERDATA_UPDATE_LOADER';
export const USERDATA_RESET_LOADER: string = 'USERDATA_RESET_LOADER';
export const USERDATA_CHANGE: string = 'USERDATA_CHANGE';
export const CALCULATION_JOURNEY_STARTED: string = 'CALCULATION_JOURNEY_STARTED';



// WEBPACK FOOTER //
// ./src/constants/UserData.js